import { getContrastingTextColor } from "PFCore/utilities/color";
import { BookingCategory } from "PFTypes";

export const getTextColor = (category: BookingCategory) =>
  category?.color ? getContrastingTextColor(category?.color, 0.7) : undefined;
